var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('ManageUser'),_c('Map'),_c('SearchGeneralGeodir'),_c('SideNavDeliveryShao'),_c('DataQuality'),_c('StreetView'),_c('Here')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }